import { PERM } from '#/config/permissions';
import { ROUTES } from '#/config/routes';

/** 客戶管理 hub 導覽卡。 */
const crmMgmtNavigate = [
  {
    to: ROUTES.customerOrder,
    title: '客戶訂單',
    subtitle: '查詢與管理客戶訂單',
    permission: PERM.CUSTOMER_ORDER_READ,
  },
  {
    to: ROUTES.quotation,
    title: '報價單',
    subtitle: '手動報價、發出與下載 Excel',
    permission: PERM.QUOTATION_READ,
  },
  {
    to: ROUTES.costEstimate,
    title: '成本試算',
    subtitle: '物料／BOM 材料成本估算',
    permission: PERM.COST_ESTIMATE_READ,
  },
  {
    to: ROUTES.salesOrder,
    title: '銷貨單',
    subtitle: '查詢與管理銷貨單',
    permission: PERM.SALES_ORDER_READ,
  },
  {
    to: ROUTES.snSalesWarranty,
    title: '序號直接銷售',
    subtitle: '直接售出與保固更正',
    permission: PERM.SALES_ORDER_READ,
  },
  {
    to: ROUTES.product,
    title: '產品管理',
    subtitle: '查詢與管理產品主檔',
    permission: PERM.PRODUCT_READ,
  },
  {
    to: ROUTES.customer,
    title: '客戶管理',
    subtitle: '查詢與管理客戶主檔',
    permission: PERM.CUSTOMER_READ,
  },
];

export default crmMgmtNavigate;
